import { Injectable } from '@angular/core';

import { ContractSignatureCheckoutPending, PaymentLinkSummaryState } from '@models/index';

// Dentro de la app nativa el WebView no tiene pestanas: la ceremonia se abre en la misma vista y el
// checkout se destruye. Aqui sobrevive la sesion que se estaba firmando para que, al volver, el
// checkout la recupere en vez de abrir otra. Solo vive en memoria: si se recarga, el carrito
// (`CartService`) tambien se pierde y no hay compra a la que volver.
@Injectable({
    providedIn: 'root'
})
export class ContractSignatureCheckoutService {
    private pending: ContractSignatureCheckoutPending | null = null;

    keep(pending: ContractSignatureCheckoutPending): void {
        this.pending = pending;
    }

    take(): ContractSignatureCheckoutPending | null {
        const pending = this.pending;
        this.pending = null;

        return pending;
    }

    // El checkout del enlace se destruye al irse a la ceremonia: su estado de navegacion espera aqui
    // para que "Ir al pago" lo restaure.
    linkState(guid: string): PaymentLinkSummaryState | null {
        return this.isPending(guid) ? (this.pending?.linkState ?? null) : null;
    }

    isPending(guid: string): boolean {
        return !!guid && this.pending?.session.guid === guid;
    }
}
